import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette/Palette/Palette';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog/ConfirmDialog';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Switch from '@opsbase/web-ui/Switch';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function OptionsSettingsSection(props) {
    const { definition, isEditable = false, onChange } = props;
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [allQuestionsSkipped, setAllQuestionsSkipped] = useState(false);
    const handleFieldUpdate = useCallback(field => value => {
        onChange({ [field]: value });
    }, [onChange]);
    const handleAction = useCallback(async () => {
        handleFieldUpdate('canAllQuestionsBeSkipped')(allQuestionsSkipped);
    }, [handleFieldUpdate, allQuestionsSkipped]);
    const handleClose = useCallback(async () => {
        setShowConfirmDialog(false);
    }, []);
    const handleChangeAllQuestionsSkipped = useCallback(value => {
        setShowConfirmDialog(true);
        setAllQuestionsSkipped(value);
    }, []);
    return (React.createElement(React.Fragment, null,
        showConfirmDialog && (React.createElement(ConfirmDialog, { onConfirm: handleAction, onClose: handleClose, agreeText: i18n.t('yes'), notAgreeText: i18n.t('cancel'), color: Palette.warning },
            React.createElement(Text, null, allQuestionsSkipped
                ? i18n.t('confirm-skippable-enable')
                : i18n.t('confirm-skippable-disable')))),
        React.createElement(Vertical, { gutter: true, padding: true, shrink: true },
            React.createElement(Horizontal, { gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
                React.createElement(Text, { variant: "h1" }, i18n.t('options')),
                React.createElement(Text, { color: "grey" }, i18n.t('select-options'))),
            React.createElement(Card, { padding: true },
                React.createElement(Vertical, { paddingY: true, gutter: true, shrink: true },
                    React.createElement(Pane, null,
                        React.createElement(Switch, { disabled: !isEditable, label: i18n.t('adhoc-descr'), checked: definition.permitAdhoc, onChange: handleFieldUpdate('permitAdhoc'), tip: i18n.t('adhoc-helptext') })),
                    React.createElement(Pane, null,
                        React.createElement(Switch, { disabled: !isEditable, checked: definition.allowIssuesAndNotes, onChange: handleFieldUpdate('allowIssuesAndNotes'), label: i18n.t('allow-issue-ad-comments'), tip: i18n.t('issuecomment-helptext') })),
                    React.createElement(Pane, null,
                        React.createElement(Switch, { disabled: !isEditable, checked: definition.canBePerformedOnlyOnNative, onChange: handleFieldUpdate('canBePerformedOnlyOnNative'), label: i18n.t('allow-only-native') })),
                    React.createElement(Pane, null,
                        definition.__typename === 'OrgTemplate' && (React.createElement(Switch, { checked: definition['lockEditingOfOpDefinition'], onChange: handleFieldUpdate('lockEditingOfOpDefinition'), label: i18n.t('lock-op-descr'), tip: i18n.t('lockop-helptext') })),
                        definition.__typename === 'OpDefinition' && (React.createElement(Switch, { disabled: !isEditable, checked: definition['lockEditingToPrimaryAdmins'], onChange: handleFieldUpdate('lockEditingToPrimaryAdmins'), label: i18n.t('lock-admins-descr'), tip: i18n.t('lockadmins-helptext') }))),
                    React.createElement(Pane, null,
                        React.createElement(Switch, { disabled: !isEditable, checked: definition.canAllQuestionsBeSkipped, onChange: handleChangeAllQuestionsSkipped, label: i18n.t('allow-all-questions-skipped') })))))));
}
export default OptionsSettingsSection;
